import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Skeleton } from "@/shared/components/ui/skeleton";

export default function AreaStatsChart({
  data,
  title,
  currency,
}) {
  const hasData = Array.isArray(data) && data.length > 0;

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100">
      {/* Title */}
      <h3 className="text-lg font-semibold mb-4 text-slate-900">
        {title}
      </h3>

      {/* Chart */}
      <div className="h-[300px] w-full flex items-center justify-center">
        {!hasData ? (
          <Skeleton className="h-full w-full rounded-xl" />
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data}>
              <defs>
                <linearGradient id="deposits" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#3b82f6" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#3b82f6" stopOpacity={0} />
                </linearGradient>

                <linearGradient id="withdrawals" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#F59E0B" stopOpacity={0.3} />
                  <stop offset="95%" stopColor="#F59E0B" stopOpacity={0} />
                </linearGradient>
              </defs>

              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />

              <XAxis
                dataKey={(d) => d.name || d.date || ""}
                tick={{ fill: "#64748b", fontSize: 12 }}
              />

              <YAxis
                tick={{ fill: "#64748b", fontSize: 12 }}
                tickFormatter={(v) => `${currency}${v}`}
              />

              <Tooltip
                formatter={(v) => [
                  `${currency}${Number(v || 0).toLocaleString()}`
                ]}
                contentStyle={{
                  background: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                }}
              />

              {/* Deposits */}
              <Area
                type="monotone"
                dataKey="deposits"
                stroke="#3b82f6"
                strokeWidth={2}
                fill="url(#deposits)"
              />

              {/* Withdrawals */}
              <Area
                type="monotone"
                dataKey="withdrawals"
                stroke="#F59E0B"
                strokeWidth={2}
                fill="url(#withdrawals)"
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}